"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defaultSettings = _interopRequireDefault(require("@/config/defaultSettings"));
var _default = exports.default = {
  state: {
    title: _defaultSettings.default.title,
    // 平台名称
    headerHeight: _defaultSettings.default.headerHeight,
    // 头部导航高度
    tabsHeight: _defaultSettings.default.tabsHeight,
    // 头部tab栏高度
    hideTabs: _defaultSettings.default.hideTabs,
    // 隐藏头部tab栏
    fixedHeader: _defaultSettings.default.fixedHeader,
    // 固定 Header
    fixedSidebar: _defaultSettings.default.fixedSidebar,
    // 固定左侧菜单栏
    siderMinWidth: _defaultSettings.default.siderMinWidth,
    // 侧边栏最小宽度，合起来时的宽度
    siderWidth: _defaultSettings.default.siderWidth,
    // 侧边栏宽度，展开时的宽度
    siderCollapsed: _defaultSettings.default.siderCollapsed,
    // 侧边栏状态
    contentWidth: _defaultSettings.default.contentWidth,
    // layout of content: `Fluid` or `Fixed`, only works when layout is topmenu
    autoHideHeader: false,
    color: '',
    isMobile: false,
    layout: '',
    multiTab: true,
    theme: 'dark',
    weak: false
  },
  mutations: {
    SET_SIDER_COLLAPSED: (state, type) => {
      state.siderCollapsed = type;
    }
  },
  actions: {}
};